<template>
  <div class="main">
    <div class="invite-list">
      <div class="head">
        <div class="head-item mobile">手机</div>
        <div class="head-item nick">昵称</div>
        <div class="head-item time">兑换时间</div>
      </div>
      <div class="invite-wrapper">
        <div class="list">
          <div
            class="list-item"
            @click="toDetail(item, 1)"
            v-for="(item, index) in recommendList"
            :key="index"
          >
            <div class="mobile item">{{ item.mobile }}</div>
            <div class="nick item">{{ item.nickName }}</div>
            <div class="time item">{{ item.payDate }}</div>
          </div>
          <div class="item-footer" v-if="recommendList.length">
            已经到底啦～
          </div>
          <div class="item-footer" v-else>暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecommendUserList } from '../../request/api/recommend'
export default {
  data () {
    return {
      recommendList: []
    }
  },
  beforeCreate () {
    document.title = `${this.$route.query.title}的邀请`
  },
  created () {
    this.userId = this.$route.query.userId
    this._getRecommendUserList()
  },
  methods: {
    async _getRecommendUserList () {
      let { data } = await getRecommendUserList({
        userId: this.$route.query.userId,
      })
      let recommendList = data || []
      recommendList.forEach(item => {
        item.mobile = item.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
      })
      this.recommendList = recommendList
    }
  }
}
</script>

<style scoped lang='less'>
.main {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 30px;
  background: #7969fc;
}
.invite-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 16px;
  .head {
    display: flex;
    align-items: center;
    padding: 0 20px;
    .head-item {
      display: flex;
      align-items: center;
      height: 100px;
      text-align: left;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      &.mobile {
        width: 279px;
      }
      &.nick {
        width: 230px;
      }
      &.time {
        flex: 1;
      }
    }
  }
  .invite-wrapper {
    flex: 1;
    overflow-y: auto;
    .list {
      .list-item {
        display: flex;
        align-items: center;
        padding: 30px 20px;
        border-bottom: 1px solid #eeeeee;
        .item {
          text-align: left;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 40px;
          &.mobile {
            width: 279px;
          }
          &.nick {
            width: 230px;
          }
          &.time {
            flex: 1;
          }
        }
      }
      .buy-item {
        display: flex;
        flex-direction: column;
        padding: 30px 30px;
        border-bottom: 1px solid #eeeeee;
        .top {
          display: flex;
          align-items: center;
          &.mar {
            margin-top: 32px;
          }
          .top-item {
            text-align: left;
            &.mobile {
              width: 212px;
            }
            &.nick {
              width: 161px;
            }
            &.time {
              width: 161px;
            }
            &.num {
              flex: 1;
              text-align: right;
            }
            .top-item-title {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 33px;
            }
            .top-item-text {
              margin-top: 12px;
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
              line-height: 40px;
            }
          }
        }
      }
      .item-footer {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
        line-height: 30px;
      }
    }
  }
}
</style>